import { VideoUIFrame } from "./VideoUIFrame";
import { useVideoUI } from "../../VideoUIContext";
import { PhaseAction } from "@platform/types/platform.types";
import { MeetingDetails } from "@platform/features/video/types/video.types";
import { useDialog } from "@shared/features/dialog/useDialog";

type Props = {
  priorityBasedPolicy: boolean;
  sharingAttendeeId: string;
  meetingScriptUserPhaseAction: PhaseAction | undefined;
  meetingDetails: MeetingDetails;
};

export const VideoUIFrameContainer = ({
  priorityBasedPolicy,
  sharingAttendeeId,
  meetingScriptUserPhaseAction,
  meetingDetails,
}: Props) => {
  const { isSidebarOpen } = useVideoUI();

  const { openDialog } = useDialog();

  const onSupportClick = () => {
    openDialog("supportTicket");
  };

  return (
    <VideoUIFrame
      priorityBasedPolicy={priorityBasedPolicy}
      sharingAttendeeId={sharingAttendeeId}
      isSidebarOpen={isSidebarOpen}
      isSupportDialogEnabled={false}
      meetingScriptUserPhaseAction={meetingScriptUserPhaseAction}
      meetingDetails={meetingDetails}
      onSupportClick={onSupportClick}
    />
  );
};

export default VideoUIFrameContainer;
